import { ServerError } from '~/infra/ErrorResponse';
export function updateRelationshipErrorMessage(error, errorTexts) {
    if (error.hasServerError(ServerError.MismatchingRelationshipVersion)) {
        return errorTexts.mismatchingRelationshipVersion();
    }
    if (error.hasServerError(ServerError.UnresolvedTemplateVariables)) {
        return errorTexts.relationship.unrecognizedCustomFields();
    }
    if (error.hasServerError(ServerError.ServiceEffectiveDateMustBeInFuture)) {
        return errorTexts.relationship.serviceEffectiveDateMustBeInFuture();
    }
    return errorTexts.unexpected();
}
